import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Lottie from "react-lottie";
import loading from "./loading.json";
import { Helmet } from "react-helmet-async";
import useFetch from "../hooks/useFetch.js";
import CareerSection1 from "../pages/CareerSection1.js";
import CareerSection2 from "../pages/CareerSection2.js";
import CareerSection3 from "../pages/CareerSection3.js";
import AcademySection4 from "../pages/AcademySection4.js";
import AcademySection5 from "../pages/AcademySection5.js";

const CareerContent = () => {
  const { slug } = useParams();
  const [academy, setAcademy] = useState(null);

  const {
    loading: academyLoading,
    data: academyData,
    error: academyError,
  } = useFetch(
    `https://devrw2.blob.core.windows.net/rw-website/strapi-data/academy/data.json`
  );

  useEffect(() => {
    if (academyData && Array.isArray(academyData)) {
      const foundAcademy = academyData.find(
        (item) =>
          item.academyTitle
            .toLowerCase()
            .replace(/[^\w\s-]/g, "")
            .replace(/[\s_-]+/g, "-")
            .replace(/^-+|-+$/g, "") === slug
      );
      setAcademy(foundAcademy);
    }
  }, [academyData, slug]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loading,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  if (academyLoading || !academy) {
    return (
      <div className="w-full flex justify-center items-center min-h-screen">
        <Lottie options={defaultOptions} height={400} width={400} />
      </div>
    );
  }

  return (
    <div className=" font-display mt-16">
      <CareerSection1 academy={academy} />
      <CareerSection2 academy={academy} />
      <div className="border-t border-b-gray-100 border border-gray-100 mt-2"></div>

      <CareerSection3 academy={academy} />
      <div className="border-t border-b-gray-100 border border-gray-100 mt-2 mb-10"></div>
    </div>
  );
};

export default CareerContent;
